export default {
  collection: null,
  collections: null,
};
